import {
  locationIdFormat,
  packingTemplateIdFormat,
} from "@redotech/redo-ids/ids";
import * as z from "zod";
import { ProductSearchResultSchema } from "./search-products";

export const searchProductsByBarcode = {
  name: "searchProductsByBarcode" as const,
  input: z.object({
    barcode: z.string(),
    locationId: locationIdFormat.schema.nullish(),
  }),
  output: z.object({
    products: z.array(ProductSearchResultSchema),
    matchedPackingTemplateId: packingTemplateIdFormat.schema
      .nullable()
      .default(null),
  }),
};
